module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('TranslateForm', {
    on: {
      "formSubmit": _vm.translateText
    }
  }), _vm._v(" "), _c('TranslateOutput', {
    domProps: {
      "textContent": _vm._s(_vm.translatedText)
    }
  }), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('img', {
    attrs: {
      "src": require("../logo.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticStyle: {
      "color": "purple",
      "position": "absolute",
      "bottom": "0",
      "left": "45%"
    }
  }, [_vm._v("Made with "), _c('i', {
    staticClass: "fa fa-code animated flash",
    attrs: {
      "aria-hidden": "true",
      "id": "code"
    }
  }), _vm._v(" and Vue.js")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c598edd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 21
// module chunks = 0